import {changeNestedValue} from "../utils/arr-path";

type Path = Array<string | number>;

export const stateChangeNestedValue = (state, path: Path, change) => {
    if (state.change) {
        state.change((v) => changeNestedValue(v, path, change));
    } else {
        state.onChange(changeNestedValue(state.value, path, change));
    }
};

export const scn = stateChangeNestedValue;
export const scnv = stateChangeNestedValue;
